import React from "react";
import PhotoSettings from "./PhotoSettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import IntlMessages from "../../../../util/IntlMessages";

const PhotoModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.dataSettings" />} key="2">
            <PhotoSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default PhotoModal;
